import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';
import { updateBasketTotals } from './utils';

export default function* listenLoadTotals() {
  yield takeEvery(basketActions.loadTotals.toString(), updateBasketTotals);
}
